import React, { useEffect, useState, useMemo,useRef } from "react";
import CustomButton from "../../AppComponent/CustomButton/CustomButton";
import { useDispatch, useSelector } from "react-redux";
import {
  settheTrackingrecordgetListDataActions,
  setTheoptions,
  setThecountBasedRenders,
  setTheTrackingDeleteActions,
  setTheTrackingEditionsActions,
  setTheTicketsStatusStatuse,
setTheTicketstRange1,

setTheTicktesRange2

} from "../../../Redux/Slice";
import { NavLink, useNavigate } from "react-router-dom";
import ReactTable from "../../AppComponent/Table";
import Select from "react-select";
import Delete from "../../AppComponent/Popup/Delete";
import Search from "@mui/icons-material/Search";
import correctIcons from "../../../Assets/AppComponent/icons/Group 359.svg";
import Pendingimg from "../../../Assets/AppComponent/icons/Group 145.svg";
import TrackingRecordApprove from "./TrackingRecordApprove";
import AccessAlarmIcon from "@mui/icons-material/AccessAlarm";
import { parseISO, addDays, differenceInDays } from "date-fns"; // Using date-fns for date manipulation

import { DateRangePicker, Stack } from "rsuite";
import subDays from "date-fns/subDays";
import startOfWeek from "date-fns/startOfWeek";
import endOfWeek from "date-fns/endOfWeek";
import "rsuite/dist/rsuite.css";
import isAfter from "date-fns/isAfter";
import { Chart } from "react-google-charts";
import Swal from "sweetalert2";
import _ from "lodash";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DeleteImages from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-05.svg";
import EditImages from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-04 (1).svg";
import ViewSymblos from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-23.svg";
import dayjs from "dayjs";

const TrackingRecords = () => {
  const dispatch = useDispatch();
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );
  const dateRangeRef = useRef(null);
  

  const state = useSelector((state) => state);
  const [RoleCreatePopup, setRoleCreatePopup] = useState(false);
  const [newpages, setNewpage] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [dtpageindex, setdtPageindex] = useState(1);
  const [dtpagesize, setdtPagesize] = useState(20);
  const [search, setsearch] = useState("");
  const [pageSize, setPageSize] = useState(20);
  const [DeletePOPUP, setDeletePOPUP] = useState(false);
  const [DeleteID, setDeleteID] = useState("");
  const [EditId, setEditID] = useState();

  const FileterState = {
    status: state.StateManagementOverallCall.TicketsStatusState?.value,
  };
  const [selectDisplay, setDisplay] = useState([]);

  const [selectVal, SetSelectval] = useState(FileterState);
  const [FState, SetStates] = useState(false);

  const [FindZeroticket, setFindZeroTickets] = useState(false);
  const [CountFroActions, setCountForActions] = useState(0);
  // Define state to manage checkbox selections, if needed
  const [selectedIds, setSelectedIds] = useState([]);
  const [checked, setchecked] = useState(false);
  const formDatas = new FormData();

  const [ListedIds, setlistedids] = useState([]);

  ////--_FIlter--------------------------
  const [Filter, SetFilter] = useState(true);
  const [TracketReport, setTicketReport] = useState({
    OpenTicket: 2,
    Closeticker: 3,
    PendingTickets: 4,
  });

  const options = [
    { value: "", label: "All" },

    { value: "open", label: "Open" },

    { value: "close", label: "Close" },
    { value: "pending", label: "Pending" },
  ];

  const [place, SetPlace] = useState("All");
  const [sel, setSelected] = useState();
  var today = new Date();
  var priorDate = new Date(new Date().setDate(today.getDate() - 30));
  var it = convert(state.StateManagementOverallCall.TicketsRange1);
  var gt = convert(state.StateManagementOverallCall.TicketsRange2);
             const today_day = dayjs().format("YYYY-MM-DD");
  
  const [range, setrange] = useState(
    state.StateManagementOverallCall.TicketsRange1 == ""
        ? [today_day ,today_day] 
      : [it, gt]
  );
  const handlechangedate = (value) => {
    if (value != null) {
      setrange((oldArray) => [...oldArray, value.slice(0, 10)]);
    }
  };
  useEffect(() => {
    if (range.length > 0 && !range.includes("NaN-aN-aN")) {
      dispatch(setTheTicketstRange1(range[0]));
      dispatch(setTheTicktesRange2(range[1]));
    }
                if(state.StateManagementOverallCall.TicketsRange1 == ""){
                  dispatch(setTheTicketstRange1(today_day));
                  dispatch(setTheTicktesRange2(today_day));
                }
  }, [range]);

  function convert(str) {
    var date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    return [date.getFullYear(), mnth, day].join("-");
  }

  const pagesize = (arg) => {
    setdtPagesize(arg);
  };
  const pageindex = (arg) => {
    //  console.log(arg, "args");
    setdtPageindex(arg);
  };

  const [yearAndMonth, setYearMpnth] = useState();
  const date = new Date();
  console.log(date.getFullYear(), "date");
  const months =
    date.getMonth() < 10 ? `0${date.getMonth() + 1}` : date.getMonth() +1;
  const displaydate =
    date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();
  const YearList = date.getFullYear();
  //var yearAndMonth = `${date.getFullYear()}-${months}`;
  useEffect(() => {
    setYearMpnth(`${date.getFullYear()}-${months}`);
  }, []);
  const [Datestate, setdata] = useState({
    date: displaydate,
    month: months,
    year: YearList,
  });
 

  useEffect(() => {
    if (range.length > 0 && !range.includes("NaN-aN-aN")) {
      const payload = {
      search: search,
      page_size: dtpagesize,
      page: dtpageindex,
      // day: Datestate.date,
      // year: Datestate.year,
      // month: Datestate.month,

      from_date: range[0],

      to_date: range[1],

      selectVal: selectVal,
    };
    dispatch(settheTrackingrecordgetListDataActions(payload));
  }
  }, [dtpageindex, dtpagesize, range, selectVal ,search]);



  useEffect(() => {
    if (state.TrackingrecordgetList.TrackingReport) {
      const Options = {
        OpenTicket:
          state.TrackingrecordgetList.TrackingReport.open_tracking_count,
        Closeticker:
          state.TrackingrecordgetList.TrackingReport.close_tracking_count,
        PendingTickets:
          state.TrackingrecordgetList.TrackingReport.pending_tracking_count,
      };
      setTicketReport(Options);
    }
  }, [state.TrackingrecordgetList.TrackingReport]);

   console.log(state.TrackingrecordgetList.TrackingReport ,"TrackingReport");
   

  useEffect(() => {
    if (state.TrackingrecordgetList.TrackingReport != null 
  
    ) {
      if (
        state.TrackingrecordgetList.TrackingReport.open_tracking_count == 0 &&
        state.TrackingrecordgetList.TrackingReport.close_tracking_count == 0 &&
        state.TrackingrecordgetList.TrackingReport.pending_tracking_count == 0
      ) {

        setFindZeroTickets(false);

      } else if (
        state.TrackingrecordgetList.TrackingReport.open_tracking_count != 0 ||
        state.TrackingrecordgetList.TrackingReport.close_tracking_count != 0 ||
        state.TrackingrecordgetList.TrackingReport.pending_tracking_count != 0
      ) {
        
        setFindZeroTickets(true);
      }

    }
  
  }, [state.TrackingrecordgetList.TrackingReport]);
  const capitalizeFirstLetter = (Letter) => {
    return Letter.charAt(0).toUpperCase() + Letter.slice(1);
  };

  const cleaningrange = () => {
    //setrange([gt,it]);
  };

  const predefinedBottomRanges = [
    {
      label: "Today",
      value: [new Date(), new Date()],
      placement: "left",
    },
    {
      label: "Yesterday",
      value: [addDays(new Date(), -1), addDays(new Date(), -1)],
      placement: "left",
    },
    {
      label: "This week",
      value: [startOfWeek(new Date()), endOfWeek(new Date())],
      placement: "left",
    },
    {
      label: "Last week",
      value: (value, index) => {
        const [start = new Date()] = value[index] || [];
        return [
          addDays(startOfWeek(start, { weekStartsOn: 0 }), -7),
          addDays(endOfWeek(start, { weekStartsOn: 0 }), -7),
        ];
      },
      placement: "left",
    },
    {
      label: "Last 30 days",
      value: [subDays(new Date(), 29), new Date()],
      placement: "left",
    },
  ];

  const handleHeaderCheckboxChange = (e) => {
    // console.log(ListedIds, "ListedIds", e);

    if (e) {
      setchecked(true);
      setSelectedIds(ListedIds);
    } else {
      setSelectedIds([]);
      setchecked(false);
    }
  };

  // Function to handle checkbox change
  const handleCheckboxChange = (id) => {
    // Check if the id is already in the selectedIds array
    const isSelected = selectedIds.includes(id);

    if (isSelected) {
      // If id is already selected, remove it from the array
      const updatedIds = selectedIds.filter((selectedId) => selectedId !== id);
      setSelectedIds(updatedIds);
    } else {
      // If id is not selected, add it to the array
      setSelectedIds([...selectedIds, id]);
    }

  };

  const handleChangesOfMulti = () => {
    // Display SweetAlert with custom HTML content
    Swal.fire({
      title: "Select Options",
      html: `
          <div style="display: flex; flex-direction: row; align-items: start;gap:20px">
          <label for="approve" style="margin-bottom: 10px;">
  
            <input type="checkbox" id="approve" name="option" value="close">
            Close</label>
              <label for="decline" style="margin-bottom: 10px;">
            <input type="checkbox" id="decline" name="option" value="open">
             Open</label>
             <label for="pending" style="margin-bottom: 10px;">
            <input type="checkbox" id="pending" name="option" value="pending">
           Pending</label>
            
  
          </div>
  
          <div id="reasonInputContainer" style="display: none; margin-top: 10px; width: 100%;">
          <label for="reasonInput" style="text-align:left;width:100%">Reason for Decline:</label>
          <input placeholder="Reason for Decline" type="text" id="reasonInput" name="reasonInput" style="width: 100%; box-sizing: border-box; padding:10px">
        </div>
        
  
        `,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#F05839",
      cancelButtonColor: "#F37738",
      confirmButtonText: "Yes, proceed!",
    }).then((result) => {
      if (result.isConfirmed) {
        // Retrieve selected options
        const selectedOptions = [];
        const checkboxes = document.querySelectorAll(
          'input[name="option"]:checked'
        );

        checkboxes.forEach((checkbox) => {
          selectedOptions.push(checkbox.value);
        });

        // Check if "Decline" was selected and get the reason input
        const isDeclined = selectedOptions.includes("decline");
        const reasonInput = document.getElementById("reasonInput").value;

        if (isDeclined && reasonInput.trim() === "") {
          // If "Decline" was selected but reason input is empty
          Swal.fire("Please provide a reason for decline", "", "error");
          return; // Exit function without proceeding
        }

        // Perform actions based on selected options
        console.log("Selected options:", selectedOptions);
        if (isDeclined) {
          console.log("Reason for decline:", reasonInput);
        }
        formDatas.append(
          "data",
          JSON.stringify({
            status: "close",
            request_type: "request",
            reason_for_decline: reasonInput,
          })
        );

        const payload = {
          status: "close",
          reason_for_decline: reasonInput,
          currentPage: currentPage,
          selectVal: selectVal,
          // month: Data.month,
          // year: Data.year,

          formDatas: formDatas,
          from_date: range[0],

          to_date: range[1],

          EditID: JSON.stringify(selectedIds),
        };

        dispatch(setTheTrackingEditionsActions(payload));
        setSelectedIds([]);
        setchecked(false);
        // Show success message using SweetAlert
      } else {
        // User cancelled, show a message or perform other actions
        console.log("User cancelled the changes.");
        Swal.fire("Cancelled", "Your changes have not been applied.", "info");
      }
    });

    // Add event listener to show/hide reason input based on "Decline" checkbox
    const declineCheckbox = document.getElementById("decline");
    const reasonInputContainer = document.getElementById(
      "reasonInputContainer"
    );

    declineCheckbox.addEventListener("change", () => {
      reasonInputContainer.style.display = declineCheckbox.checked
        ? "block"
        : "none";
    });
  };



  function tochange(e) {
    setdtPageindex(1);
    debouncedSearch(e);

  }
  const debouncedSearch = useMemo(
    () =>
      _.debounce((e) => {
        setsearch(e);
      }, 500),
    []
  );
  React.useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);


  const calculateDateDifference = (createdAt, expireDate) => {
    const createdDate = Date.parse(createdAt);
    const expireDateObj = Date.parse(expireDate);

    if (isNaN(createdDate) || isNaN(expireDateObj)) {
      console.error("Invalid date format:", { createdAt, expireDate });
      return NaN;
    }

    const differenceInTime = expireDateObj - createdDate;
    const differenceInDays = Math.ceil(
      differenceInTime / (1000 * 60 * 60 * 24)
    );
    return differenceInDays;
  };

  const getIconColor = (createdAt, expireTime) => {
    // Convert expireTime to an integer
    const expireDays = parseInt(3);

    // Calculate the expiration date by adding expireDays to createdAt
    const expirationDate = addDays(createdAt, expireDays);

    // Calculate the difference in days between expiration date and current date
    const daysDifference = differenceInDays(expirationDate, new Date());

    // Log the difference in days for debugging
    console.log(daysDifference, "daysDifference", expirationDate, expireDays);

    // Determine the color based on the difference in days
    if (daysDifference < 0 || daysDifference == 0) {
      return "red"; // Expired, set color to red
    }
    // else if (daysDifference <= 2) {
    else if (daysDifference == 2) {
      // return "yellow"; // Expiring within 7 days, set color to yellow
      return "green";
    } else if (daysDifference == 1) {
      return "red"; // Not expiring soon, set color to green
    }
  };

  const columns = [
  
    {
      Header: "Tnx Id",
      accessor: "",
      Cell: ({ row }) => {
        const userId = row.original.id;
        const lastFourDigits = userId ? userId.toString().slice(-6) : "---";
        const originalString = row.original.status;

        const createdAt = row.original.created_at
          ? parseISO(row.original.created_at)
          : null;
        const expireTime = row.original.category_id?.expire_time
          ? row.original.category_id.expire_time
          : null;
        console.log(originalString.toLowerCase() == "close", "asjdaksjh");
        // const expireTime = true ? 3 : null;
        const iconColor =
          createdAt && expireTime
            ? getIconColor(createdAt, expireTime)
            : "grey"; // Default color if dates are not available

        return (
          <>
            {userId ? (
              <span
                style={{ display: "flex", gap: "10px", alignItems: "center" }}
              >
                {originalString.toLowerCase() != "close" &&
                createdAt &&
                expireTime ? (
                  <AccessAlarmIcon style={{ color: iconColor }} />
                ) : (
                  <>
                    {originalString.toLowerCase() == "close" ? (
                      <AccessAlarmIcon style={{ color: "green" }} />
                    ) : null}
                  </>
                )}

                {lastFourDigits}
                {/* {expireTime !== null
                  ? `(${differenceInDays(expireTime, createdAt)} days)`
                  : ""} */}
              </span>
            ) : (
              <span>---</span>
            )}
          </>
        );
      },
    },
//       {
//   Header: "U-ID",
//   accessor: "user_id.local_uid",
//   Cell: ({ row }) => {
//     const userId = row.original?.user_id?.local_uid;

//     // Handle null, undefined, empty string, or whitespace
//     const displayValue =
//       userId == null || String(userId).trim() == "" ? "--" : userId;

//     return <p className="PTAGs">{displayValue}</p>;
//   },
// },
  {
      Header: "Employee Code",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            <div
              className="UserName"
              style={{ cursor: "pointer" }}
            >
              <div className="">
                <span>
                  {row.row.original.user_id?.user_uid != null &&
                  row.row.original.user_id?.user_uid != undefined &&
                  row.row.original.user_id?.user_uid != ""
                    ? row.row.original.user_id?.user_uid
                    : "--"}
                </span>
              </div>
            </div>
          </>
        );
      },
    },
    {
      Header: "Name",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.user_id.first_name ? (
              <span>{row.row.original.user_id.first_name}</span>
            ) : (
              <span>---</span>
            )}
          </>
        );
      },
    },

    {
      Header: "Created Date",
      accessor: "",
      Cell: (row) => {
        const dateString = row.row.original.created_at;
        const dateObject = new Date(dateString);
        const hours = dateObject.getHours();
        const minutes = dateObject.getMinutes();
        const seconds = dateObject.getSeconds();
        const amOrPm = hours >= 12 ? "PM" : "AM";
        const twelveHourFormat = hours % 12 || 12;

        const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

        const formattedTime = `${twelveHourFormat}:${formattedMinutes} ${amOrPm}`;

        return (
          <>
            <span>
              {`${
                row.row.original.created_at.slice(0, 10) + "  " + formattedTime
              }`}
            </span>
          </>
        );
      },
    },

    {
      Header: "Email",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.user_id.email ? (
              <span>{row.row.original.user_id.email}</span>
            ) : (
              <span>---</span>
            )}
          </>
        );
      },
    },

    {
      Header: "Status",
      accessor: "status",
      Cell: (row) => {
        const originalString = row.row.original.status;
        const capitalizedString = capitalizeFirstLetter(originalString);
        return (
          <>
            {row.row.original.status != undefined ? (
              <>
                {row.row.original.status.toLowerCase() == "pending" ? (
                  <div className="StatusList">
                    <img src={Pendingimg} />
                    <span>{capitalizedString}</span>
                  </div>
                ) : (
                  <>
                    {row.row.original.status.toLowerCase() == "open" ? (
                      // <div className="StatusList">
                      //   <div className="DeclineStatus">
                      //     <span>x</span>
                      //   </div>
                      //   <span>{capitalizedString}</span>
                      // </div>
                      <div className="StatusList">
                        <img src={correctIcons} />
                        <span>{capitalizedString}</span>
                      </div>
                    ) : (
                      <>
                        {row.row.original.status.toLowerCase() == "close" ? (
                          <div className="StatusList">
                            <img src={correctIcons} />
                            <span>{capitalizedString}</span>
                          </div>
                        ) : null}
                      </>
                    )}
                  </>
                )}
              </>
            ) : (
              <span>---</span>
            )}
          </>
        );
      },
    },

    {
      Header: "Actions",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            <div
              class="actions"
              style={{
                display: "flex",
                justifyContent: "flex-start",
                gap: "5px",
              }}
            >
              <button
                className="btn Status"
                onClick={(e) => {
                  setCountForActions(1);
                  setEditID(row.row.original.id);
                  setRoleCreatePopup(true);
                }}
                component="span"
              >
                <span className="OuterActionSpan">
                <span  className="EditImages">
                    <img src={EditImages}/>
                  </span>
                  <span className="ActionsList"> Edit </span>
                </span>
              </button>

              <button
                type="button"
                class="btn Status"
                onClick={(e) => {
                  setDeleteID(row.row.original.id);
                  setDeletePOPUP(true);
                }}
              >
                <span className="OuterActionSpan">
                <span  className="EditImages">
                    <img src={DeleteImages}/>
                  </span>
                  <span className="ActionsList"> Delete </span>
                </span>
              </button>

              <button
                className="btn Status"
                onClick={(e) => {
                  setCountForActions(2);

                  setEditID(row.row.original.id);
                  setRoleCreatePopup(true);
                }}
                // disabled={true}
                component="span"
              >
               <span className="OuterActionSpan">
                   <span  className="EditImages">
                    <img src={ViewSymblos}/>
                  </span>

                  <span className="ActionsList"> View </span>
                </span>

              </button>

              {/* <button
                ///style={{background:"transparent"}}
                className="Status"
                style={{ borderRadius: "5px" }}
              >
                {row.row.original.user_id &&
                row.row.original.user_id.first_name ? (
                  <input
                    style={{ marginRight: "10px" }}
                    type="checkbox"
                    id={`checkbox-${row.row.original.id}`}
                    className="custom-checkbox2"
                    onChange={() => {
                      handleCheckboxChange(row.row.original.id);
                    }}
                    checked={selectedIds.includes(row.row.original.id)}
                  />
                ) : (
                  <span>---</span>
                )}
              </button> */}
            </div>{" "}
          </>
        );
      },
    },

    // {
    //   id: "checkboxColumn", // Unique ID for the column
    //   Header: (
    //     <input
    //       type="checkbox"
    //       id={`checkbox1`}
    //       className="custom-checkbox1"
    //       onChange={(e) => {
    //         handleHeaderCheckboxChange(e.target.checked);
    //       }}
    //       checked={checked}
    //     />
    //   ),
    //   accessor: "", // This accessor might need to be updated based on your data structure
    //   Cell: (row) => {
    //     return (
    //       <>
    //         {row.row.original.user_id && row.row.original.user_id.first_name ? (
    //           <input
    //             style={{ marginRight: "10px" }}
    //             type="checkbox"
    //             id={`checkbox-${row.row.original.id}`}
    //             className="custom-checkbox1"
    //             onChange={() => {
    //               handleCheckboxChange(row.row.original.id);
    //             }}
    //             checked={selectedIds.includes(row.row.original.id)}
    //           />
    //         ) : (
    //           <span>---</span>
    //         )}
    //       </>
    //     );
    //   },
    // },
  ];

  const ClearState = (Counts) => {
    if (Counts == 2) {
      SetSelectval({
        ...selectVal,

        status: "",
      });
      dispatch(setTheTicketsStatusStatuse({value:"",label:"All"}));

      setdtPageindex(1);
    }
  };

  //--------_____Filter-----------Based---On----Status--
  const count = (Counts, values, sel, SelectedValues) => {
    setdtPageindex(1);
    setSelected(sel);
    SetStates(true);
    dispatch(setTheTicketsStatusStatuse(SelectedValues));
    if (values == "Open") {
      SetSelectval({
        ///Completed
        ...selectVal,

        status: "open",
      });
    } else if (values == "Pending") {
      ///Pending
      SetSelectval({
        ...selectVal,

        status: "pending",
      });
    } else if (values == "Close") {
      //Decline
      SetSelectval({
        ...selectVal,
        is_decline: true,
        is_pending: "",
        approved: "",
        status: "close",
      });
    } else if (values == "Approved") {
      //Approve
      SetSelectval({
        ...selectVal,

        status: "close",
      });
    } else if (values == "All") {
      //Approve

      SetSelectval({
        ...selectVal,

        status: "",
      });
    }

    if (sel == "") {
      SetSelectval({
        ...selectVal,

        status: "",
      });
    }
  };


  const HandleSubmits = () => {
    if (DeleteID != undefined) {
      const payload = {
        DeleteID: DeleteID,
        currentPage: dtpageindex,
        day: Datestate.date,
        year: Datestate.year,
        month: Datestate.month,
        selectVal: selectVal,
        Mytickets:2,
      };
      dispatch(setTheTrackingDeleteActions(payload, setDeletePOPUP(false)));
    }
  };

  const pie_chart_data_Ticket = [
    ["Ticket", "count"],
    ["Closed Tickets", TracketReport.Closeticker],
    ["Open Tickets", TracketReport.OpenTicket],
    ["Pending Tickets", TracketReport.PendingTickets],
  ];

  const optionsTickets_dia = {
    title: "Ticket Details",
    pieHole: 0.5,
    is3D: false,
    slices: {
      0: { color: "#11734B" }, // Green for Verified Employees
      1: { color: "blue" }, // Blue for Declined Employees
      2: { color: "red" }, // Red for Pending Employees
    },
    titleTextStyle: {
      fontSize: 24, // Title font size

      paddingBottom: 30,
    },
    legend: {
      textStyle: {
        fontSize: 16, // Legend font size
      },
    },
    tooltip: {
      textStyle: {
        fontSize: 14, // Tooltip font size
      },
    },
    chartArea: {
      // width: "90%", // Adjust chart area to fit better
      // height: "80%",
      width: "90%", // Adjust chart area to fit better
      height: "80%",
      top: 50, // Adjust top margin to create space for the title
    },
  };


  const handleNext = (next) => {    
    setdtPageindex(next + 1);
};

const GotoEnteredPage =(gotopage)=>{
 setdtPageindex(gotopage)
}

const handlePrevious = (previous) => {
if (previous != 0) {
  setdtPageindex(previous);

}
};

const openMe = ()=>{
  const rsAnimFade = document.querySelector('.rs-anim-fade');
  if (rsAnimFade) {
    rsAnimFade.style.setProperty('left', '892.344px', 'important');
    rsAnimFade.style.setProperty('top', '179.109px', 'important');   
  }
 }

 const CloseDateRange = ()=>{
  const rsAnimFade = document.querySelector('.rs-anim-fade');
  if (rsAnimFade) {
    rsAnimFade.style.setProperty('display', 'none', 'important');
    // rsAnimFade.style.setProperty('top', '184.109px', 'important');   
  }
 }
const getZoomFactor = () => {
  const zoom = document.body.style.zoom;
  return zoom ? parseFloat(zoom) / 100 : 1;
};

const alignDateRangePicker = (pickerNode) => {
  const picker =
    pickerNode?.root || pickerNode?.container || pickerNode;

  const popup = document.querySelector(
    ".rs-picker-popup.rs-picker-popup-daterange"
  );

  if (!picker || !popup) return;

  const zoom = getZoomFactor();
  const rect = picker.getBoundingClientRect();

  const popupWidth = popup.offsetWidth;
  const popupHeight = popup.offsetHeight;

  const viewportWidth = window.innerWidth / zoom;
  const viewportHeight = window.innerHeight / zoom;

  const scrollX = window.scrollX / zoom;
  const scrollY = window.scrollY / zoom;

  let left = rect.right / zoom - popupWidth + scrollX;
  let top = rect.bottom / zoom + 8 + scrollY;

  if (left < 8) left = 8;
  if (left + popupWidth > viewportWidth - 8) {
    left = viewportWidth - popupWidth - 8;
  }

  if (top + popupHeight > viewportHeight + scrollY - 8) {
    top = rect.top / zoom - popupHeight - 8 + scrollY;
  }

  popup.style.position = "absolute";
  popup.style.left = `${left}px`;
  popup.style.top = `${top}px`;
};
  return (
    <>
      <div className={stateDisplay ? "outterContent" : "inner-Content"}>
        <div
          className="Header-Details ClientBranch row"
          style={{ padding: "14px 28px" }}
        >
          <div
            class="col-sm-7 auto"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "flex-start",
            }}
          >
            <h3>Tickets</h3>

          </div>

          {/* <div className="Add-User col-sm-5">
            <button
              onClick={(e) => {
                setCountForActions(0);

                setRoleCreatePopup(true);
                setEditID("");
              }}
              className="ButtonCSS"
            >
              Create Ticket
            </button>
          </div> */}
        </div>


        <div
          className="row Filters"
          style={{
            padding: "15px 28px",
            margin: "0px",
            position: "relative",
            zIndex: "90",
               
            marginLeft: "0px",
            marginRight: "0px",
            top: "-13px",
          }}
        >
          {
          FindZeroticket == true 

          ? (
            <div className="col-4">
              <div class="card">
                <Chart
                  chartType="PieChart"
                  data={pie_chart_data_Ticket}
                  options={optionsTickets_dia}
                  width={"400px"}
                  height={"290px"}
                />
              </div>
            </div>
          ) : (
            <div className="col-6">
              <div
                class="card"
                style={{
                  display: "flex",
                  alignItems: "left",
                  justifyContent: "left",
                  height: "299px",
                  width: "425px",
                  fontFamily: " MediumMetropolisweight !important",
                }}
              >
                <div className="card-body">
                  <h3
                    style={{ fontWeight: "900" }}
                    className="DashboardCardHeader"
                  >
                    Tickets Details
                  </h3>
                  <p className="DashboardCardHeader"> No data available</p>
                </div>
              </div>
            </div>
          )}


<div className="col-6 SelectedDates seleceteddatedTickets" style={{marginTop:"-21px"}} >
          <label
              for="validationCustom01"
              class="form-label"
               style={{width:"37%", textAlign:"left"}}
            >
              {/* State Name */}
              Select Date
              <span style={{ color: "red" }}>*</span>

            </label>


            <div className="datepicker_dash" style={{ marginRight: "-15px" }}>
              <DateRangePicker

              defaultValue={
                state.StateManagementOverallCall.TicketsRange1 == ""
                    ? [new Date(range[0]), new Date(range[1])]
                  : [
                      new Date(
                        state.StateManagementOverallCall.TicketsRange1
                      ),
                      new Date(
                        state.StateManagementOverallCall.TicketsRange2
                      ),
                    ]
              }
              

                                                                   ref={dateRangeRef}

          onOpen={() => {
            
    setTimeout(() => {
      alignDateRangePicker(dateRangeRef.current);
    }, 80);
  }}


  style={{
    width: "100%",
    padding: "0px 5px",
  }}

                disabledDate={(date) => isAfter(date, new Date())}
                editable={false}
                appearance="default"
                placement="bottomEnd"
                size="lg"
                ranges={predefinedBottomRanges}
                placeholder="From - To"
                // style={{ width: 300, padding: 10 }}
                onClean={(e) => cleaningrange(e)}
                onChange={(e) => {
                  if (e != null && e.length === 2) {
                    const [startDate, endDate] = e;
                    const diffDays = differenceInDays(endDate, startDate);
                    // if (diffDays === 30) {
                    //   // Since we are using inclusive range, difference should be 30 for 31 days
                    //   setrange([]);
                    //   e.forEach((newValue) => {
                    //     const tzoffset = new Date().getTimezoneOffset() * 60000; // offset in milliseconds
                    //     const localISOTime = new Date(newValue - tzoffset)
                    //       .toISOString()
                    //       .slice(0, -1);
                    //     handlechangedate(localISOTime);
                    //   });
                    // } else if (diffDays < 30) {
                    //   setrange([]);
                    //   e.forEach((newValue) => {
                    //     const tzoffset = new Date().getTimezoneOffset() * 60000; // offset in milliseconds
                    //     const localISOTime = new Date(newValue - tzoffset)
                    //       .toISOString()
                    //       .slice(0, -1);
                    //     handlechangedate(localISOTime);
                    //   });
                    // } else {
                    //   toast.error("Please select a range of exactly 31 days.", {
                    //     position: toast.POSITION.TOP_RIGHT,
                    //   });
                    // }

                    setrange([]);
                    e.forEach((newValue) => {
                      const tzoffset = new Date().getTimezoneOffset() * 60000; // offset in milliseconds
                      const localISOTime = new Date(newValue - tzoffset)
                        .toISOString()
                        .slice(0, -1);
                      handlechangedate(localISOTime);
                    });
                  }
                }}
              />
            </div>
          </div>

        </div>

        <div style={{ padding: " 0px 40px", marginTop: "-13px" }}>
          <ReactTable
            data={state.TrackingrecordgetList.TrackingrecordgetListData}
            columns={columns}
            totalItems={state.TrackingrecordgetList.Total_Count}
            currentPage={currentPage}
            onChange={tochange}
            setCurrentPage={setCurrentPage}
            pagesize={pagesize}
            // onPrevious={handlePrevious}
            // onNextpage={handleNext}
            dtpagesize={pageSize}
            dtpageindex={dtpageindex}
            pageindex={pageindex}
            onPrevious={handlePrevious}
            onNextpage={handleNext}
            GotoEnteredPage={GotoEnteredPage}

            datacount={state.TrackingrecordgetList.Total_Count}
            // onPageChange={handlePageChange}
            // onFirstPage={handleFirstPage}
            // OnhandleLastpgae={HandleLastPage}
            // value={state.NumberCounts.Options}
            // options={options}
            // Filter={false}
            // count={count}
            // ClearState={ClearState}
            // placeHold={place}

            values={state.StateManagementOverallCall.TicketsStatusState}
            options={options}
            ApproveRequestFilter={true}
            Filter={Filter}
            count={count}
            ClearState={ClearState}
            placeHold={place}
          />
          {/* 
          <div
            className="row"
            style={{
              padding: "15px 28px",
              margin: "0px",
              position: "relative",
              zIndex: "30",
                 
              marginLeft: "0px",
              marginRight: "0px",
              top: "-79px",
              // top:"-57px"
            }}
          >
            <div className="col"></div>

            <div
              className="col"
              style={{ display: "flex", justifyContent: "end" }}
            >
              <button
                style={{ background: "#F47E38", color: "white" }}
                onClick={(e) => {
                  handleChangesOfMulti(e);
                }}
                className="ButtonCSS"
                disabled={selectedIds.length == 0 ? true : false}
              >
                Submit
              </button>
            </div>
          </div> */}
        </div>
      </div>

      {RoleCreatePopup ? (
        <TrackingRecordApprove
          setShow={setRoleCreatePopup}
          show={RoleCreatePopup}
          currentPage={dtpageindex}
          EditID={EditId}
          selectVal={selectVal}
          // Datestate={Datestate}
          from_date={range[0]}
          to_date={range[1]}
          ForReadOnly={CountFroActions}
          search={search}
        />
      ) : null}

      {DeletePOPUP ? (
        <Delete
          show={DeletePOPUP}
          setShow={setDeletePOPUP}
          onSubmit={HandleSubmits}
          Content={"Do you want to delete the Ticket"}

        />
      ) : null}
    </>
  );
};

export default TrackingRecords;
